(function (app) {
    app.provider("ssoApi", [function () {
        this.$get = [
            "portalApiGateway", function (portalApiGateway) {
                var service = {};
                service.initiateRightBridgeSso = function () {
                    return portalApiGateway.post("/RightBridgeSso");
                },
                service.initiateRetireUpSso = function () {
                    return portalApiGateway.post("/RetireUpSso");
                },
                service.getSureLcUser = function () {
                    return portalApiGateway.get("/SureLcSso/User");
                },
                service.initiateSureLcSso = function(lastname) {
                    return portalApiGateway.post("/SureLcSso?ln=" + lastname);
                },
                service.initiateMapleLifeCalculatorSso = function () {
                    return portalApiGateway.post("/MapleLifeSsoV2");
                },
                service.initiateCannexSso = function() {
                    return portalApiGateway.post("/CannexSso/");
                },
                service.initiateAnnuityRateWatchSso = function() {
                    return portalApiGateway.post("/AnnuityRateWatchSso/");
                },
                service.initiateLtcSelectSso = function() {
                    return portalApiGateway.post("/LtcSelectSso/");
                },
                service.initiateAnnexusSso = function() {
                    return portalApiGateway.post("/AnnexusSso/");
                },
                service.initiateSimonSso = function () {
                    return portalApiGateway.get("/SimonSso/", null);
                },
                service.initiateFirelightSso = function(samlData) {
                    //console.log(samlData);
                    return portalApiGateway.post("/FirelightSso", samlData);
                },
                service.initiateIpipelineEappsSso = function (appModel) {
                    return portalApiGateway.post("/IpipelineSso/EApps", !!appModel ? appModel : {});
                },
                service.initiateIpipelineSso = function(relayStateId) {
                    return portalApiGateway.post("/IpipelineSso/Resources/" + relayStateId);
                },
                service.initiateTaylorMethodSso = function () {
                    return portalApiGateway.post("/TaylorMethodSso/");
                },       
                service.initiateOfficeDepotSso = function () {
                    return portalApiGateway.post("/OfficeDepotSso/");
                },     
                /*service.initiatePowerOfZeroSso = function () {
                    return portalApiGateway.post("/PowerOfZeroSso/");
                },*/
                service.initiatePowerOfZeroSsoV2 = function () {
                    return portalApiGateway.post("/PowerOfZeroSso/Token");
                },
                //0 = CS | 2 = Elevate | 2 = Elevate4Life
                /*service.initiateCreativeServicesSso = function () {
                    var platinumLevelId = 0;  //0 - CS/Elevate4Life | 2 - Elevate
                    return portalApiGateway.post("/PlatinumSso/" + platinumLevelId);
                },
                service.initiateElevateSso = function () {
                    var platinumLevelId = 2;  //0 - CS/Elevate4Life | 2 - Elevate
                    return portalApiGateway.post("/PlatinumSso/" + platinumLevelId);
                },
                service.initiateElevate4LifeSso = function () {
                    var platinumLevelId = 0;  //0 - CS/Elevate4Life | 2 - Elevate
                    return portalApiGateway.post("/PlatinumSso/" + platinumLevelId);
                },*/
                service.initiateEnsightSso = function () {
                    return portalApiGateway.post("/EnsightSso");
                };
               
                return service;
            }
        ];
    }
    ]);
})(window.app);